module.exports = __webpack_public_path__ + "img/ic_32_register_facebook.ab29ee49.svg";